/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterCartChange } from '../types/FilterCartChange'
import { defaultFormatTimeZone } from '../utils/consts'

interface CartChangeContextType {
  filters: FilterCartChange
  setFilters: (filters: FilterCartChange) => any
}

const initialState: CartChangeContextType = {
  filters: {
    geoipStates: [],
    geoipCities: [],
    date: {
      initialDate: moment('2021-07-01').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-Cart-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const CartChangeFiltersContext = createContext(initialState)

const CartChangeFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <CartChangeFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </CartChangeFiltersContext.Provider>)
}

export default CartChangeFiltersContextProvider
